// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://rrrchnzqzjbnphuurbio.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InJycmNobnpxempibnBodXVyYmlvIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Mzc3Mzk3NTgsImV4cCI6MjA1MzMxNTc1OH0.pDegtHexV9XOZ8nFI9yVfkdaQ5UInJ_lg9rx9hcetHA";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);